<template>
  <div class="synchronous">
    <div class="synchronous-header">
      <div>
        <el-button type="primary" @click="handelAddCouponBtn(1)">新增优惠券</el-button>
        <span class="synchronous-header-tip">新增优惠券之后，需要稍后刷新查看创建结果</span>
      </div>
      <div class="forms-container">
        <el-form :rules="rulesSearch" :model="searchForm" class="search-form" ref="searchFormRef">
          <el-form-item label="活动名称" prop="activityName">
            <el-input
              style="width:200px"
              :maxlength="255"
              v-model="searchForm.activityName"
              placeholder="活动名称"
            />
          </el-form-item>
          <el-form-item label="创建时间" prop="createTimeArr">
            <el-date-picker
              v-model="searchForm.createTimeArr"
              type="daterange"
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd HH:mm:ss"
              :clearable="false"
              :default-time="['00:00:00', '23:59:59']"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="创建状态">
            <el-select v-model="searchForm.createStatus" placeholder="请选择创建状态">
              <el-option
                v-for="item in createStatusList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="券类型">
            <el-select v-model="searchForm.type" placeholder="请选择券类型">
              <el-option
                v-for="item in typeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="活动状态">
            <el-select v-model="searchForm.activityStatus" placeholder="请选择活动状态">
              <el-option
                v-for="item in activityStatusList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <!-- 操作按钮 -->
            <el-button type="warning" @click="onFormSearch">查询</el-button>
            <el-button type="warning" plain @click="onFormReset">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <my-table
      :tableData="table.tableData"
      :headerList="table.headerList"
      :loading="table.loading"
      :page-size="params.pageSize"
      :currentPage="params.pageNo"
      :total="table.total"
      @currentPage-change="handlePageChange"
      @sizePage-change="handleSizeChange"
    >
      <!-- 自定义表头 -->
      <template #activityStatusHeader>
        <div>
          活动状态
          <el-tooltip class="item" effect="dark" content="活动关闭后，根据支付宝规则无法再次开启该活动" placement="top">
            <i class="el-icon-question"></i>
          </el-tooltip>

        </div>
      </template>
      <template v-slot:couponValue="{ data }">
        <div v-if="data.type === 'DISCOUNT_VOUCHER'">
          {{data.discount}}折(最高优惠{{data.ceilingAmountBd}}元)
        </div>
        <div v-if="data.type === 'FIX_VOUCHER'">
          {{data.amountBd}}元
        </div>
      </template>
      <template v-slot:validTimeAll="{ data }">
        <div>开始：{{data.publishStartTime}}</div>
        <div>结束：{{data.publishEndTime}}</div>
      </template>
      <template v-slot:createStatusStr="{ data }">
        <div v-if="data.createStatus === 2" style="color:red;">创建失败，请在详情中重新提交</div>
        <div v-else>{{data.createStatusStr}}</div>
      </template>
      <template v-slot:codeStatus="{ data }">
        <el-tag type="success" v-if="data.codeStatus === 1">同步成功</el-tag>
        <el-tag type="danger" v-if="data.codeStatus === 2">同步失败</el-tag>
        <el-tag type="info" v-if="data.codeStatus === 3">同步中</el-tag>
      </template>
      <template v-slot:stock="{ data }">
        {{data.sendCount}}/{{data.quantity}}
        <el-tooltip class="item" effect="dark" :content="data.activityStatus ? '活动已关闭': '修改库存'" placement="top">
          <i :class="data.activityStatus ? 'el-icon-plus noAdds' : 'el-icon-plus adds' " @click="handelModifyInventory(data)"></i>
        </el-tooltip>

      </template>
      <template v-slot:activityStatus="{ data }">
        <el-switch
          :value="data.activityStatus"
          :active-value="0"
          :inactive-value="1"
          :disabled="data.activityStatus === 1"
          @change="updateState(data)"
        >
        </el-switch>
      </template>
      <template v-slot:operation="{ data }">
        <span class="table-link" style="margin-right: 5px;" @click="handelAddCouponBtn(2,data)">编辑</span>
        <span class="table-link" @click="handelAddCouponBtn(3,data)">详情</span>
      </template>
    </my-table>
    <addCouponZfb ref="addCouponRefZfb" @refresh="onFormResetAdd"></addCouponZfb>
    <changeStatu ref="changeStatuRef" @change="handelChangeClose"></changeStatu>
    <changeStock ref="StockRef" @changeSrock="handelChangeSrock"></changeStock>
  </div>
</template>

<script>
import mini from "@/api/mini";
const MiniModel = new mini();
import myTable from '@/components/my-table.vue'
import addCouponZfb from "./component/addCouponZfb.vue";
import debounce from "@/utils/debounce.js";
import changeStatu from './component/changeStatu.vue'
import changeStock from './component/changeStock.vue'
export default {
  components:{
    myTable,
    addCouponZfb,
    changeStatu,
    changeStock
  },
  data() {
    return {
      searchForm:{
        activityName:'',
        createTimeArr:[],
        createStatus:'',
        type:'',
        activityStatus:'',
      },
      params:{
        pageNo:1,
        pageSize:10,
      },
      table:{
        loading:false,
        total:0,
        tableData: [],
        headerList:[
          {
            prop: 'createTime',
            label: '创建时间',
            width: '170',
            // customRender:'customName'
            // 自定义表头
            // customHeader: 'customDateHeader'
          },
          {
            prop: 'activityName',
            label: '活动名称',
            width: '160'
          },
          {
            prop: 'createStatusStr',
            label: '创建状态',
            // width: '120',
            customRender:'createStatusStr',

          },
          {
            prop: 'typeStr',
            label: '券类型',
            width: '120'
          },
          {
            prop: 'couponValue',
            label: '券面额',
            width: '150',
            customRender: 'couponValue'
          },
          {
            prop: 'applicableObjectStr',
            label: '适用对象',
            // width: '200'
          },
          {
            prop: 'validTimeAll',
            label: '有效时间',
            width: '210',
            customRender:'validTimeAll'
          },
          {
            prop: 'stock',
            label: '库存',
            width: '120',
            customRender: 'stock'
          },
          {
            prop: 'activityStatus',
            label: '活动状态',
            width: '120',
            customRender: 'activityStatus',
            customHeader:'activityStatusHeader'
          },
          {
            prop: 'codeStatus',
            label: '同步状态',
            width: '120',
            customRender: 'codeStatus',
          },
          {
            prop: 'operation',
            label: '操作',
            width: '120',
            customRender: 'operation',
            fixed: 'right', //是否固定列
          }
        ]
      },
      createStatusList: [
        {
          label: "全部",
          value: "",
        },
        {
          label: "创建中",
          value: 0,
        },
        {
          label: "创建成功",
          value: 1,
        },
        {
          label: "创建失败",
          value: 2,
        },
      ],
      typeList: [
        {
          label: "全部",
          value: "",
        },
        {
          label: "满减券",
          value: "FIX_VOUCHER",
        },
        {
          label: "折扣券",
          value: "DISCOUNT_VOUCHER",
        },
      ],
      activityStatusList: [
        {
          label: "全部",
          value: "",
        },
        {
          label: "开启",
          value: 0,
        },
        {
          label: "关闭",
          value: 1,
        },
      ],
      rulesSearch:{
        productId: [
          { validator: this.validateNumber, trigger: 'blur' } // 自定义校验规则
        ]
      }
    }
  },
  created() {
    this.getZfbActivityPage()
  },
  methods:{
    handelChangeClose() {
      this.getZfbActivityPage()
      console.log('确认关闭活动')
    },
    handelChangeSrock() {
      setTimeout(() => {
        this.getZfbActivityPage()
      }, 1000);
      console.log('修改库存')
    },
    updateState(row) {
      console.log(row,'row=updateState修改状态')
      this.$refs.changeStatuRef.open(row)
    },
    // 自定义的数字校验规则
    validateNumber(rule, value, callback) {
      if (value === '') {
        // 如果值为空，不做任何校验
        callback();
      } else if (!/^\d+$/.test(value)) {
        // 如果值不为空，并且不是数字，报错
        callback(new Error('请输入数字'));
      } else {
        // 如果值是数字，校验通过
        callback();
      }
    },
    // 表单搜素
    onFormSearch() {
      debounce(
        () => {
          this.$refs['searchFormRef'].validate((valid) => {
            if (valid) {
              this.params.pageNo = 1;
              this.getZfbActivityPage();
            } else {
              console.log('error submit!!');
              return false;
            }
          });
        },
        500,
        true
      );
    },
    onFormReset() {
      debounce(()=> {
        this.searchForm = {
          activityName:'',
          createTimeArr:[],
          createStatus:'',
          type:'',
          activityStatus:'',
        }
        this.$refs['searchFormRef'].resetFields();
        this.getZfbActivityPage()
      },1000,true)
    },
    onFormResetAdd() {
      this.getZfbActivityPage()
    },
    reset() {
      this.params = {
        pageNo:1,
        pageSize:10,
      }
      this.getZfbActivityPage()
    },
    // 快手商品券同步-列表
    async getZfbActivityPage(){
      let appKeyMini = localStorage.getItem("appKeyMini");
      console.log(appKeyMini,'appKeyMini==11122')
      // return
      this.table.loading = true;
      let createTimeStart = ''
      let createTimeEnd = ''
      if(this.searchForm.createTimeArr.length > 0) {
        createTimeStart = this.searchForm.createTimeArr[0]
        createTimeEnd = this.searchForm.createTimeArr[1]
      }else {
        createTimeStart = ''
        createTimeEnd = ''
      }
      const res = await MiniModel.zfbActivityPageMarket(
        {
          ...this.params,
          appKey:appKeyMini,
          ...this.searchForm,
          createTimeStart,
          createTimeEnd,
          activityName: this.searchForm.activityName.trim(),
        }
      ).finally(()=>{
        this.table.loading = false;
      })
      console.log(res,'res==1=getZfbActivityPage')
      if(res.data.code === 200) {
        this.table.tableData = res.data.data.list
        this.table.total = res.data.data.total;
        this.params.pageNo = res.data.data.pageNo
        console.log(this.table.tableData,'this.table.tableData')
      }else{
        this.$message({
          message: res.data.message,
          type: 'error'
        });
      }
    },
    handelAddCouponBtn(type,row) {
      console.log(type,row,'type')
      this.$refs.addCouponRefZfb.openDialog(type,row)
    },
    // 分页
    handlePageChange(val) {
      this.params.pageNo = val
      this.getZfbActivityPage()
    },
    // 每页显示条数
    handleSizeChange(val) {
      this.params.pageSize = val
      this.getZfbActivityPage()
    },
    // 修改库存
    handelModifyInventory(data) {
      console.log(data,'data=修改库存')
      if(data.activityStatus) return
      this.$refs.StockRef.openStock(data)
    }
  }
}
</script>

<style scoped lang="less">
.synchronous{
  &-header{
    //display: flex;
    //justify-content: space-between;
    //align-items: center;
    &-tip{
      color: #666;
      margin-left: 10px;
      font-size: 12px;
    }
    &__icons{
      i{
        font-size: 22px;
        cursor: pointer;
        margin-right: 50px;
        color: #409eff;
      }
    }
  }
}
.forms-container{
  margin-top: 10px;
}
.adds{
  color: #409eff;
  cursor: pointer;
}
.noAdds{
  color: #999;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/zfbMiniProgram/couponGroupNew/eventManagement.vue